// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#openbay .confirmation-details-box{background:#f9fafb;border:1px solid #e9e9e9;padding:0 1rem}@media(min-width:768px){#openbay .confirmation-details-box{padding:1rem 2rem}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
